import React from 'react';
import PropTypes from 'prop-types';
import RecentStakesLayout from './components/RecentStakesLayout';

const RecentStakesPerformers = (props) => {
    const {
        data: {
            data,
        },
    } = props;

    const isRecentStakesData = data && data.recentStakeCategoryData
                                    && Object.keys(data.recentStakeCategoryData).length > 0;
    if (!isRecentStakesData) {
        return (
            <section
                className="hp-recentStakesPerformers__container--text-center"
            >
                No recent top performers information for this sire is available
            </section>
        );
    }

    return (
        <div
            className="hp-weatherbys hp-weatherbys__recentStakesPerformers
            hp-recentStakesPerformers__container"
        >
            <div className="sireinfo">Recent Top Performers</div>
            <RecentStakesLayout data={data.recentStakeCategoryData} />
        </div>
    );
};

RecentStakesPerformers.propTypes = {
    data: PropTypes.shape({
        data: PropTypes.shape({
            progenyRecentPerformersflat: PropTypes.array,
        }),
    }),
};

export default RecentStakesPerformers;



// WEBPACK FOOTER //
// ./src/js/horse/recentStakesPerformers/RecentStakesPerformers.jsx